import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging } from '../../../actions/log';
import styles from './Button.module.less';
import { setIframeVisible } from '../../../actions/layout';
import { gameCDKSetVisible } from '../../../actions/gamecdk';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectLoginClose = createSelector(
  state => state.user,
  user => user.loginBoxClose,
);
export default memo(
  ({
    soft,
    info = {},
    logInfo = {},
    clickCallbackTag = false,
    reductionTag = () => {},
    hoverTag = false,
  }) => {
    let btnClassName = styles.sbutton_open;
    const dispatch = useDispatch();
    const logInfoData = useSelector(selectLogInfo);
    const userInfo = useSelector(selectUserInfo);
    const [isClickBtn, setIsClickBtn] = useState(false);
    const loginBoxClose = useSelector(selectLoginClose);
    const [btnText, setBtnText] = useState(soft?.type === 4 ? '官网购买' : '立即购买');

    useEffect(() => {
      if (clickCallbackTag) {
        handleBuySoft(soft, logInfo);
        reductionTag();
      }
    }, [clickCallbackTag]);

    useEffect(() => {
      if (loginBoxClose?.result === 0) {
        setIsClickBtn(false);
      }
    }, [loginBoxClose]);

    useEffect(() => {
      if (userInfo && userInfo?.st && isClickBtn) {
        let gameCdkPrice = 0;
        let gameCdkSid = 0;
        try {
          let priceStr = soft_info?.currentPrice || soft_info?.originalPrice;
          gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
          gameCdkSid = soft_info?.sid;
        } catch (error) {}
        dispatch(
          gameCDKSetVisible({
            isShow: true,
            soft: { gameCdkPrice, gameCdkSid },
            source: logInfo.source || logInfoData.source,
          }),
        );
      }
    }, [isClickBtn, userInfo]);

    const handleBuySoft = useCallback(
      (soft_info, logInfo_para) => {
        const logParam2 = {
          source: logInfo_para.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: soft?.type,
          id: soft?.id,
        };
        let param3 = {};
        try {
          param3 = JSON.parse(soft?.bizInfo);
        } catch (e) {
          param3 = {};
        }
        // 按钮点击打桩
        dispatch(
          logging({
            category: 'C',
            action: 'Sales_Card_Button',
            label: '',
            param2: logParam2,
            param3: param3,
          }),
        );

        if (soft_info?.extInfo?.sourceType === 1) {
          dispatch(
            setIframeVisible({
              visible: true,
              url: soft_info?.extInfo?.sourceUrl,
              soft: soft_info,
              source: logInfo.source,
            }),
          );
        } else if (soft_info?.extInfo?.sourceType === 2) {
          if (userInfo && userInfo?.st) {
            let gameCdkPrice = 0;
            let gameCdkSid = 0;
            try {
              let priceStr = soft_info?.currentPrice || soft_info?.originalPrice;
              gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
              gameCdkSid = soft_info?.extInfo?.sid;
            } catch (error) {}
            dispatch(
              gameCDKSetVisible({
                isShow: true,
                soft: { gameCdkPrice, gameCdkSid },
                source: logInfo.source || logInfoData.source,
              }),
            );
          } else {
            setIsClickBtn(true);

            window.CallNativeMethod('logout');
            window.CallNativeMethod('login');
          }
        } else {
          window.open(soft_info?.extInfo?.sourceUrl);
        }
      },
      [dispatch, logInfoData],
    );
    return (
      <div
        className={`${btnClassName} ${info?.className} ${hoverTag ? styles.btn_hover : ''}`}
        onClick={e => {
          e.preventDefault();
          handleBuySoft(soft, logInfo);
        }}
      >
        {btnText}
        <span className={`${styles.triangle} ${info?.tagClass}`} />
      </div>
    );
  },
);
